var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38696 4.93349L9.38672 4.93361C9.11509 5.07081 8.92541 5.29126 8.85781 5.54724C8.78937 5.80633 8.85216 6.08132 9.04725 6.30232C9.04737 6.30246 9.04749 6.30259 9.04761 6.30273L10.5162 7.98216L9.01557 9.70777C9.01542 9.70794 9.01527 9.70811 9.01512 9.70828C8.8222 9.9276 8.75735 10.1969 8.82729 10.4529C8.89604 10.7046 9.0873 10.9173 9.35579 11.0525C9.88231 11.319 10.5895 11.2183 10.9619 10.7953L12.982 8.53814L12.982 8.53815L12.983 8.53696C13.2723 8.20853 13.2723 7.75433 12.983 7.42589L12.983 7.42589L12.9823 7.4251L10.9939 5.1918C10.8013 4.97296 10.5322 4.86246 10.2525 4.82029C9.97677 4.77872 9.66408 4.79397 9.38696 4.93349Z",
    fill: "#7E7C81",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61304 4.93349L6.61328 4.93361C6.88491 5.07081 7.07459 5.29126 7.14219 5.54724C7.21063 5.80633 7.14784 6.08132 6.95275 6.30232C6.95263 6.30246 6.95251 6.30259 6.95239 6.30273L5.48384 7.98216L6.98443 9.70777C6.98458 9.70794 6.98473 9.70811 6.98488 9.70828C7.1778 9.9276 7.24265 10.1969 7.17271 10.4529C7.10396 10.7046 6.9127 10.9173 6.64421 11.0525C6.11769 11.319 5.41047 11.2183 5.03805 10.7953L3.01802 8.53814L3.01802 8.53815L3.01698 8.53696C2.72767 8.20853 2.72767 7.75433 3.01698 7.42589L3.01697 7.42589L3.01768 7.4251L5.00605 5.1918C5.19867 4.97296 5.46778 4.86246 5.7475 4.82029C6.02323 4.77872 6.33592 4.79397 6.61304 4.93349Z",
    fill: "#7E7C81",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeCircle);
export default __webpack_public_path__ + "static/media/code-circle.2fdfbcbad135e08321924a6b9121eddc.svg";
export { ForwardRef as ReactComponent };